module.exports = __webpack_public_path__ + "static/scale-model-of-o'neill-house-in-los-angeles-california-12caee396b6f61c922acd78b5bdfcf5c.png";